export const WH_CHARM = {
  title: "A spell for your bracelet",
  note: "Fan-made spells, just for fun.",
  className: "border-sky-200/30 bg-[#0a1430]/95",
  items: [
    "Sigil of Small Light: draw a circle with a star inside, and a tiny lantern glows in your palm.",
    "Feather Step: three curved lines and a dot let you float down any staircase like a leaf.",
    "Ink Bloom: tap your pen twice on paper and the ink grows into a field of tiny flowers.",
    "Whisper Seal: a closed eye inside a square keeps a secret safe until you say its name.",
    "Rain Ribbon: a wavy line under a crescent calls a gentle rain for thirsty gardens.",
    "Warm Hands: a spiral drawn on your palm keeps your fingers toasty on winter nights.",
    "Pathfinder: an arrow inside a ring points you home, wherever you are.",
    "Bubble Shield: two overlapping circles make a soft bubble that keeps you dry.",
    "Starlight Map: a dotted triangle shows the stars above, even on a cloudy night.",
    "Mend Thread: a zigzag stitched with gold ink fixes torn cloth and broken bracelet string.",
    "Breeze Wing: a feather shape inside a circle sends a cool wind on hot days.",
    "Echo Shell: a spiral like a seashell repeats the last kind thing someone said to you.",
    "Lantern Moth: draw wings around a dot and a glowing moth guides you through the dark.",
    "Calm Water: a flat line inside a circle smooths the waves on any pond or worried heart.",
    "Bloom Window: a square with a flower in each corner makes plants grow toward your window.",
    "Brave Heart: a star inside a heart gives you courage for one hard moment.",
    "Quiet Steps: a line of tiny dots lets you walk without a sound.",
    "Friend's Thread: tie your bracelet while drawing a loop, and you'll always find your best friend.",
    "Moon Mirror: a crescent inside a circle shows your reflection glowing silver.",
    "Sweet Dreams: a cloud with three stars above it brings a peaceful sleep.",
    "Color Splash: a burst of five lines turns plain beads into rainbow beads for one day.",
    "Lost & Found: a question mark inside a circle tells you where you left your pen.",
  ],
};

export const IV_CHARM = {
  title: "A whisper from the Maiden Court",
  note: "Fan-made court whispers, just for fun.",
  className: "border-orange-200/30 bg-[#1a0d06]/95",
  items: [
    "Even a rat can become a butterfly, if a friend believes in her.",
    "A weed that grows in the dungeon is still a flower. Keep growing.",
    "Smile like a butterfly, plan like a squirrel, and stay loyal like an eagle.",
    "The kindest heart in the palace is also the toughest. Never forget that.",
    "May your body stay healthy enough to chase chickens and pull weeds.",
    "Rumors fade, but true friends stay. Choose yours wisely.",
    "A villainess with a good heart is the best kind of heroine.",
    "May your arrows fly true and your tea stay unpoisoned.",
    "Dance through the festival like no one is trying to ruin it.",
    "The court is full of masks. This bracelet is your real face.",
    "When the world calls you a rat, wear it with pride.",
    "May every swap in your life be a lucky one.",
    "Beauty fades. Courage and kindness last forever.",
    "Even a dungeon can feel like home with the right friend.",
    "Being underestimated is your secret weapon.",
    "May the Crown Prince's storms never rain on your garden.",
    "A true friend will pull you out of a frozen well. Be that friend.",
    "Peony, plum blossom or weed, every flower has its season.",
  ],
};

export const MD_CHARM = {
  title: "A melody from Gusu",
  note: "Fan-made blessings, just for fun.",
  className: "border-cyan-200/30 bg-[#05131a]/95",
  items: [
    "May someone wait for you, even for thirteen years.",
    "Lotus seeds, lotus root soup and a family that loves you. May you have all three.",
    "May your flute call friends, not fierce corpses.",
    "No noise in the Cloud Recesses, but your heart can sing as loud as it wants.",
    "May you always have a jar of Emperor's Smile and someone to share it with.",
    "Take the righteous path, even if you have to walk it alone.",
    "May the bunnies of Gusu always hop your way.",
    "The one who waits by the gate is the one who truly loves you.",
    "May your bonds be stronger than any sect rule.",
    "Wherever you wander, may a guqin song guide you home.",
    "May the Yunmeng lotus pier always welcome you back.",
    "May you smile freely, like the wind over the lotus lake.",
    "Some people are worth breaking 3,000 rules for.",
    "May every night hunt end with laughter and a full stomach.",
    "Ask, and know your heart. Then follow it.",
    "May your sword stay sharp and your heart stay kind.",
    "Even a ghost general can be the gentlest friend.",
    "May the red ribbon in your hair bring you good fortune.",
  ],
};

export const TGCF_CHARM = {
  title: "A heavenly blessing",
  note: "Fan-made blessings, just for fun.",
  className: "border-red-200/30 bg-[#1f0a0e]/95",
  items: [
    "May a thousand lanterns light your way home tonight.",
    "May red butterflies guard you wherever you wander.",
    "May your heart stay kind, even when the world is not.",
    "Body in the abyss, heart in paradise. May you always find your light.",
    "May someone wait for you as faithfully as the moon waits for night.",
    "May every flower you carry stay fresh, like the one held in the rain.",
    "May your wishes reach the heavens on the smoke of a quiet prayer.",
    "May your luck turn bright, even if you were once the scrap-collecting god.",
    "May your umbrella always be there when the rain begins.",
    "May the silver butterflies whisper only good news to you.",
    "May your red string never tangle and never break.",
    "May you be welcomed in every shrine, big or small.",
    "May eight hundred years feel like a single sweet afternoon with the one you love.",
    "May your sword protect the gentle and your heart forgive the lost.",
    "May the Ghost City lanterns glow warm for you, never scary.",
    "May every bow you make to the heavens be answered with kindness.",
    "May you fall, rise and ascend again, stronger every time.",
    "May your bracelet remind you: you are worth waiting for.",
    "May the lucky dice always land in your favor.",
    "May a blessing fall on you like petals in the wind.",
  ],
};

export const DR_CHARM = {
  title: "A word from Monokuma",
  note: "Fan-made Monokuma lines, just for fun.",
  className: "border-pink-200/30 bg-[#1c0710]/95",
  items: [
    "Upupupu! A bracelet this cute? That's despairingly adorable!",
    "Congratulations! You picked a bracelet. Now try not to lose it during the class trial!",
    "Hope or despair? Why not both, in matching beads!",
    "Puhuhu! Wear this and everyone will know you're the Ultimate Bracelet Collector!",
    "A gift from your headmaster! Don't worry, it's totally not a trap. Probably.",
    "Beads are like students. They're best when they're all lined up and following the rules!",
    "Upupu! Even despair looks good in these colors!",
    "Attention, students! A new bracelet has been chosen. Please react with maximum excitement!",
    "This bracelet is hope-certified and despair-approved. Upupupu!",
    "Strung by hand with care, which is more than I can say for my school rules!",
    "Wear it to the class trial. The jury will be very impressed. Bear-y impressed!",
    "Nighttime is officially in effect. Sweet dreams, and don't take off your bracelet!",
    "Puhuhu! Black, white and fabulous. Just like me!",
    "No punishment today! You picked well. This time...",
    "Every bracelet has a secret. Yours is that it's adorable. Upupupu!",
    "Ding dong! The headmaster says your style is the Ultimate kind!",
    "I'm a bear, not a jeweler, but even I know this one's a winner!",
    "Despair-ately cute! Wear it with pride, student!",
    "Upupu! Hope shines brighter when it's on your wrist!",
    "Remember: friendship, hope and bracelets. That's the school motto now. I just decided!",
  ],
};

export const AD_CHARM = {
  title: "Maomao's medicine note",
  note: "Fun history facts, not medical advice.",
  className: "border-emerald-200/30 bg-[#062019]/95",
  items: [
    "Willow bark contains salicin. People chewed it for pain for thousands of years, and it led to the invention of aspirin.",
    "Penicillin was discovered in 1928 when Alexander Fleming noticed mold killing bacteria in a forgotten dish.",
    "Foxglove gives us digitalis, a heart medicine still used today. The plant itself is very poisonous.",
    "Quinine, from the bark of the cinchona tree, was the first effective treatment for malaria.",
    "Artemisinin, a malaria medicine, came from sweet wormwood, an herb found in old Chinese medical texts. Tu Youyou won a Nobel Prize for it in 2015.",
    "Ancient Egyptians put honey on wounds. Honey is naturally antibacterial.",
    "Morphine comes from the opium poppy and is named after Morpheus, the Greek god of dreams.",
    "The word \"pharmacy\" comes from the Greek \"pharmakon\", which means both remedy and poison.",
    "Paracelsus, a 1500s physician, said \"the dose makes the poison\". Almost anything is harmful in a big enough amount.",
    "\"Vaccine\" comes from the Latin word \"vacca\", meaning cow. Edward Jenner used cowpox to protect against smallpox in 1796.",
    "Insulin was first used to treat a person with diabetes in 1922, in Toronto.",
    "Peppermint contains menthol, which makes your skin and mouth feel cool.",
    "Ginseng's Chinese name means roughly \"person root\", because the root can look like a little person.",
    "Arsenic was once used in medicines and even in bright green wallpaper dye, before people understood how toxic it is.",
    "Hippocrates, often called the father of medicine, lived in ancient Greece around 400 BC.",
    "Chamomile has been brewed as a calming tea since ancient times.",
    "Licorice root is one of the most common herbs in traditional Chinese medicine, often used to balance other herbs.",
    "Pufferfish contain tetrodotoxin, which is much more poisonous than cyanide. Only specially licensed chefs may prepare it in Japan.",
    "Wilhelm Röntgen discovered X-rays in 1895. One of the first X-ray pictures showed his wife's hand and ring.",
    "In 1847, Ignaz Semmelweis showed that doctors washing their hands saved many mothers' lives.",
    "Aloe vera gel has been used on burns and dry skin since ancient times.",
    "Ether was first publicly shown as an anesthetic for surgery in Boston in 1846.",
    "Cinnamon was once so valuable that it was a gift fit for kings and was used in ancient Egyptian embalming.",
    "Many modern medicines started as plants. Scientists still search rainforests for new ones.",
  ],
};
